import List from "@/components/list";

const Table = (args) => {
  const { listeners } = args;
  const isParty = args.props['isParty'] || 1
  const RCSelectionChange = listeners["selection-change"] || function () { };
  const editSmallClass = listeners["editSmallClass"] || function () { };
  const deleteSmallClass = listeners["deleteSmallClass"] || function () { };

  const Deal = ({ props: { vo } }) => {
    let { row } = vo
    let dealConf = [
      [
        "icon-edit",
        "编辑",
        () => {
          editSmallClass(row);
        },
        "offlineClass:update",
      ],
      [
        "icon-delete",
        "删除",
        () => {
          deleteSmallClass(row);
        },
        "offlineClass:delete",
      ],
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  }

  const AccountTableConfig = [
    // {
    //   type: "selection",
    //   label: "main",
    // },
    {
      label: "小班名称",
      prop: "smallClassName",
      minWidth: "200",
      showOverflowTooltip: true,
    },
    {
      label: "小班简称",
      prop: "classChildName",
      minWidth: "120",
      showOverflowTooltip: true,
    },
    {
      label: "学员数量",
      prop: "enrollNum",
      minWidth: "100",
      showOverflowTooltip: true,
    },
  ]

  if (isParty == 1) {
    AccountTableConfig.push({
      label: "党校同步状态",
      prop: "classPushStatusName",
      minWidth: "100",
      showOverflowTooltip: true,
    })
    AccountTableConfig.push({
      label: "上次同步时间	",
      prop: "classPushTime",
      minWidth: "160",
      showOverflowTooltip: true,
    })
  }

  AccountTableConfig.push({
    label: "操作",
    fixed: "right",
    width: "80",
    render: (vo) => <Deal vo={vo} />,
  })

  return <List {...args} talbeCols={AccountTableConfig} onSelectionChange={RCSelectionChange} />;

}

export default Table;
